"use client";

import { Slider } from "@/components/ui/slider";
import {
  selectFilterOptions,
  selectSearchStatus,
} from "@/feature/flight/search/state/selectors";

import { setFilters } from "@/feature/flight/search/state/slices/extract-flight-filter.slice";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { memo, useEffect, useMemo, useState } from "react";
import AccordionSection from "./accordion-section";

const PriceRange = memo(() => {
  const dispatch = useAppDispatch();
  const { isResponseEnd, error } = useAppSelector(selectSearchStatus);
  const { selectOption, defaultOption } = useAppSelector(selectFilterOptions);
  const isPriceRangeDisabled = !isResponseEnd || error;

  const min = defaultOption?.price_range?.[0] ?? 0;
  const max = defaultOption?.price_range?.[1] ?? 1000;

  const defaultRange = useMemo(
    () => defaultOption?.price_range ?? [min, max],
    [defaultOption?.price_range, min, max],
  );
  const selectedRange = useMemo(
    () => selectOption?.price_range ?? defaultRange,
    [selectOption?.price_range, defaultRange],
  );

  const [localRange, setLocalRange] = useState<number[]>(selectedRange);

  const handleChange = (val: number[]) => {
    setLocalRange(val);
  };

  const handeValueCommit = (val: number[]) => {
    if (
      (defaultRange[0] === val[0] && defaultRange[1] === val[1]) ||
      (val[0] === min && val[1] === max)
    ) {
      dispatch(setFilters({ price_range: undefined }));
    } else {
      dispatch(setFilters({ price_range: val }));
    }
  };

  useEffect(() => {
    if (
      localRange[0] !== selectedRange[0] ||
      localRange[1] !== selectedRange[1]
    ) {
      setLocalRange(selectedRange);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRange]);

  return (
    <AccordionSection
      value="price"
      label="Price Range"
      disabled={isPriceRangeDisabled}
    >
      <Slider
        disabled={isPriceRangeDisabled}
        value={localRange.length ? localRange : [min, max]}
        min={min}
        max={max}
        step={1}
        onValueChange={handleChange}
        onValueCommit={handeValueCommit}
      />
      <div className="flex justify-between">
        <p className="text-sm">BDT {localRange[0] ?? min}</p>
        <p className="text-sm">BDT {localRange[1] ?? max}</p>
      </div>
    </AccordionSection>
  );
});

PriceRange.displayName = "PriceRange";
export default PriceRange;
